/* eslint-disable no-console */
import Glide from './vendors/glide.min';

const photoGrid = {
  detailCardTopOffset: -1,
  responseData: null,
  insertAfter: (newNode, referenceNode) => {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  },
  getLastElementInRow: (item) => {
    let node = null;
    let prevNode = null;
    [].map.call(document.querySelectorAll('.photo-grid > div:not(.photo-grid-detail-card)'), (sibling) => {
      if (sibling.offsetTop > item.offsetTop && node === null) {
        node = prevNode;
      }
      prevNode = sibling;
    });
    // If node is null, return the last item in the list
    if (node === null) {
      node = prevNode;
    }
    return node;
  },
  scrollToDetailCard: () => {
    const detailCard = document.querySelector('.photo-grid-detail-card');
    const header = document.querySelector('.header');
    window.scrollTo({
      top: detailCard.offsetTop - header.clientHeight,
      behavior: 'smooth',
    });
  },
  onCloseDetail: () => {
    photoGrid.removeItemDetail();
    photoGrid.removeActivePhotoCard();
  },
  onWindowResize: () => {
    let detailCard = document.querySelector('.photo-grid-detail-card');
    if (detailCard === null) {
      return;
    }
    // console.log(`${detailCard.offsetTop}/${photoGrid.detailCardTopOffset}`);
    if (detailCard.offsetTop !== photoGrid.detailCardTopOffset && photoGrid.detailCardTopOffset !== -1) {
      photoGrid.detachItemDetail();
      const activeCard = document.querySelector('.photo-grid .active');
      photoGrid.addItemDetail(activeCard);
    }
    // Reset prop, because we've re-added to page
    detailCard = document.querySelector('.photo-grid-detail-card');
    photoGrid.detailCardTopOffset = detailCard.offsetTop;
  },
  handleResponseData: (item) => {
    const newRowItem = photoGrid.getLastElementInRow(item);
    const div = document.createElement('div');
    div.innerHTML = photoGrid.responseData;
    photoGrid.insertAfter(div.firstChild, newRowItem);
    photoGrid.addDetailEventHandlers();
    photoGrid.scrollToDetailCard();
  },
  detachItemDetail: () => {
    const detailCard = document.querySelector('.photo-grid-detail-card');
    if (detailCard) {
      photoGrid.removeDetailEventHandlers();
      detailCard.parentNode.removeChild(detailCard);
    }
  },
  removeItemDetail: () => {
    const detailCard = document.querySelector('.photo-grid-detail-card');
    if (detailCard) {
      photoGrid.removeDetailEventHandlers();
      detailCard.parentNode.removeChild(detailCard);
      // Dump response data
      photoGrid.responseData = null;
    }
  },
  addItemDetail: (item) => {
    if (photoGrid.responseData) {
      photoGrid.handleResponseData(item);
      return;
    }
    photoGrid.getDetailContentById(item.getAttribute('data-photo-id'), (response) => {
      photoGrid.responseData = response;
      photoGrid.handleResponseData(item);
      document.getElementById('photoGridDetailCard').focus();
    });
  },
  removeActivePhotoCard: () => {
    const activeCard = document.querySelector('.photo-grid .active');
    if (activeCard) {
      activeCard.classList.remove('active');
    }
  },
  removeDetailEventHandlers: () => {
    window.removeEventListener('resize', photoGrid.onWindowResize);
    const closeBtn = document.querySelector('.photo-grid-detail-card .close-btn');
    closeBtn.removeEventListener('click', photoGrid.onCloseDetail);
  },
  addDetailEventHandlers: () => {
    window.addEventListener('resize', photoGrid.onWindowResize);
    const closeBtn = document.querySelector('.photo-grid-detail-card .close-btn');
    closeBtn.addEventListener('click', photoGrid.onCloseDetail);
    // Slider
    const slider = document.querySelector('.photo-grid-detail-card .simple-slider');
    if (slider.querySelectorAll('.glide__slide').length > 1) {
      // Set autoplay from global param, then check to see if local setting was passed
      let autoplay = window.autoplayInterval;
      if (!autoplay) {
        autoplay = 0;
      }
      if (slider.getAttribute('data-glide-autoplay')) {
        autoplay = parseInt(slider.getAttribute('data-glide-autoplay'), 10);
      }
      // Add glide
      const glide = new Glide(slider, {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        focusAt: 'center',
        gap: 0,
        autoplay,
        breakpoints: {},
      });
      glide.mount();
    }
  },
  getDetailContentById: (id, callback) => {
    const url = `${window.getColorItemDetail}?id=${id}`;
    fetch(url)
      .then(res => res.text())
      .then((out) => {
        if (callback) {
          callback(out);
        }
      })
      .catch(err => console.log(err));
  },
  addEventHandlers: () => {
    if (document.querySelectorAll('.photo-card')) {
      [].map.call(document.querySelectorAll('.photo-card'), item => item.addEventListener('click', () => {
        photoGrid.removeItemDetail();
        photoGrid.removeActivePhotoCard();
        photoGrid.addItemDetail(item);
        item.classList.add('active');
      }));
    }
  },
  init: () => {
    photoGrid.addEventHandlers();
  },
};
photoGrid.init();
/* eslint-enable no-console */
